import { useContext } from "react";
import { formatDateString } from "../../../utils";
import { DateTimeRange, DateTimeRangeField, formatDateTimeRangeValueToObject } from "../../form/fields";
import { GraphQLTableColumn } from "../../GraphQL";
import { AppConfig, AppConfigContext } from "../AppConfigContext";
import DateTimeColumn from "./DateTimeColumn";

export function DateColumnTemplate<T extends object = {}>(params?: GraphQLTableColumn<T> & {
  allowEmptyDateOnFilter?: boolean
}): GraphQLTableColumn<T> {
  return DateTimeColumn<T>({
    minWidth: 100,
    Cell: ({ value, bodyCellProps }: any) => {
      const appConfig = useContext(AppConfigContext);
      const prettified = formatDateString(value, appConfig?.dataFormatMoment, appConfig?.timeZone, appConfig.serverTimeZone, appConfig.serverDateTimeFormatMoment);
      return <span title={prettified} {...bodyCellProps}>{prettified}</span>;
    },
    Filter: ({ column }: any) =>
      <AppConfigContext.Consumer>
        {(value) =>
          <DateTimeRangeField
            placeholder="Find..."
            value={column.filterValue}
            onChange={column.setFilter}
            serverDateTimeFormat={value.serverDateFormatMoment}
            allowEmpty={params?.allowEmptyDateOnFilter}
          />
        }
      </AppConfigContext.Consumer>,
    filterValueModifier: (value: DateTimeRange, context: AppConfig) =>
      formatDateTimeRangeValueToObject(
        value,
        context.serverDateFormatMoment,
        context.timeZone,
        context.serverTimeZone,
      ),
    ...params || {
      accessor: "" as any,
    },
    excelProps: {
      numFmt: "mm/dd/yyyy",
      width: 10,
      filterButton: true,
      ...params?.excelProps,
    },
  });
}

export default DateColumnTemplate;
